var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.25,
  d: "M2 2v3.156M5.156 5.156H2M2.405 4.478A7.98 7.98 0 0 1 9 1a8.001 8.001 0 0 1 0 16c-4.417 0-8-3.583-8-8"
})));
export default SvgReload;